/* RESPONSIBLE TEAM: team-frontend-tech */
import { helper as buildHelper } from '@ember/component/helper';
import numberFormatter from 'embercom/lib/number-formatter';

export const numberFormatterHelper = (params) => numberFormatter(parseInt(params[0], 10) || 0);

export default buildHelper(numberFormatterHelper);
